import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Process from './pages/Process';
import HowItWorks from './pages/HowItWorks';
import Impact from './pages/Impact';
import FAQ from './pages/FAQ';
import GetStarted from './pages/GetStarted';
import ObserverLanding from './pages/ObserverLanding';
import PrincipalLanding from './pages/PrincipalLanding';
import AdminLogin from './pages/AdminLogin';
import UnifiedLogin from './pages/UnifiedLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminPanel from './pages/AdminPanel';
import AdminCommunications from './pages/AdminCommunications';
import OperationsDashboard from './pages/OperationsDashboard';
import ParentLogin from './pages/ParentLogin';
import ParentDashboard from './pages/ParentDashboard';
import ParentMessages from './pages/ParentMessages';
import ParentSupport from './pages/ParentSupport';
import ParentResources from './pages/ParentResources';
import ParentRewards from './pages/ParentRewards';
import ParentMoodJournal from './pages/ParentMoodJournal';
import ParentGoals from './pages/ParentGoals';
import ParentCommunity from './pages/ParentCommunity';
import ParentGroupSessions from './pages/ParentGroupSessions';
import ParentCoGuardians from './pages/ParentCoGuardians';
import ObserverLogin from './pages/ObserverLogin';
import ObserverDashboard from './pages/ObserverDashboard';
import ObserverMoodEntry from './pages/ObserverMoodEntry';
import ObserverGoalCreate from './pages/ObserverGoalCreate';
import ObserverAIReport from './pages/ObserverAIReport';
import ObserverSessionLogs from './pages/ObserverSessionLogs';
import ObserverEvents from './pages/ObserverEvents';
import ObserverEarnings from './pages/ObserverEarnings';
import ObserverWithdrawal from './pages/ObserverWithdrawal';
import ObserverSupport from './pages/ObserverSupport';
import ObserverAddInquiry from './pages/ObserverAddInquiry';
import ObserverRuleBook from './pages/ObserverRuleBook';
import ObserverToday from './pages/ObserverToday';
import ObserverActiveSession from './pages/ObserverActiveSession';
import ObserverDailyReport from './pages/ObserverDailyReport';
import ObserverSelfReflection from './pages/ObserverSelfReflection';
import ObserverEscalation from './pages/ObserverEscalation';
import ObserverReportsList from './pages/ObserverReportsList';
import ObserverReportDetail from './pages/ObserverReportDetail';
import ObserverSessionsList from './pages/ObserverSessionsList';
import ObserverCalls from './pages/ObserverCalls';
import ObserverVideoCall from './pages/ObserverVideoCall';
import ObserverAudits from './pages/ObserverAudits';
import ObserverAuditDetail from './pages/ObserverAuditDetail';
import ObserverRegister from './pages/ObserverRegister';
import ObserverNDA from './pages/ObserverNDA';
import ObserverApplicationStatus from './pages/ObserverApplicationStatus';
import ObserverAvailability from './pages/ObserverAvailability';
import ObserverHandbook from './pages/ObserverHandbook';
import ObserverTraining from './pages/ObserverTraining';
import ObserverAssignment from './pages/ObserverAssignment';
import ParentInsights from './pages/ParentInsights';
import PrincipalLogin from './pages/PrincipalLogin';
import PrincipalRedFlags from './pages/PrincipalRedFlags';
import PrincipalSupport from './pages/PrincipalSupport';
import PrincipalObservers from './pages/PrincipalObservers';
import PrincipalChildAssignment from './pages/PrincipalChildAssignment';
import PrincipalDashboard from './pages/PrincipalDashboard';
import PrincipalStudents from './pages/PrincipalStudents';
import PrincipalAnalytics from './pages/PrincipalAnalytics';
import PrincipalEvents from './pages/PrincipalEvents';
import PrincipalEarnings from './pages/PrincipalEarnings';
import PrincipalStudentAssignment from './pages/PrincipalStudentAssignment';
import PrincipalObserverPerformance from './pages/PrincipalObserverPerformance';
import PrincipalConsultations from './pages/PrincipalConsultations';
import ObserverPerformance from './pages/ObserverPerformance';
import ObserverQualityMetrics from './pages/ObserverQualityMetrics';
import ObserverCallAnalysis from './pages/ObserverCallAnalysis';
import ObserverPrepNotes from './pages/ObserverPrepNotes';
import ObserverCoaching from './pages/ObserverCoaching';
import PrincipalRecognition from './pages/PrincipalRecognition';
import PrincipalRecordings from './pages/PrincipalRecordings';
import PrincipalBusiness from './pages/PrincipalBusiness';
import PrincipalTrainingHandover from './pages/PrincipalTrainingHandover';
import PrincipalWeeklyQuestions from './pages/PrincipalWeeklyQuestions';
import PrincipalMeetings from './pages/PrincipalMeetings';
import PrincipalChildDetail from './pages/PrincipalChildDetail';
import PrincipalObserverDetail from './pages/PrincipalObserverDetail';
import PrincipalSessionHistory from './pages/PrincipalSessionHistory';
import PrincipalMonthlyReports from './pages/PrincipalMonthlyReports';
import PrincipalReviewCenter from './pages/PrincipalReviewCenter';
import PrincipalPolicyBook from './pages/PrincipalPolicyBook';
import PrincipalRuleBook from './pages/PrincipalRuleBook';
import PrincipalChat from './pages/PrincipalChat';
import PrincipalScheduleManagement from './pages/PrincipalScheduleManagement';
import ObserverPreCall from './pages/ObserverPreCall';
import ObserverPostCall from './pages/ObserverPostCall';
import ObserverCareer from './pages/ObserverCareer';
import ObserverPayslips from './pages/ObserverPayslips';
import ChildTimeline from './pages/ChildTimeline';
import ChildCelebration from './pages/ChildCelebration';
import ParentWeeklySummary from './pages/ParentWeeklySummary';
import ParentDailyInsight from './pages/ParentDailyInsight';
import ParentReportDetail from './pages/ParentReportDetail';
import ParentMonthlyReport from './pages/ParentMonthlyReport';
import ParentMonthlyReportsList from './pages/ParentMonthlyReportsList';
import ParentSubscription from './pages/ParentSubscription';
import { ParentPredictiveInsights, PrincipalPredictiveInsights } from './pages/PredictiveInsights';
import PrincipalPayslips from './pages/PrincipalPayslips';
import RuleBook from './pages/RuleBook';
import { DemoLogin, DemoDashboard, DemoReportView } from './pages/DemoPortal';
import InvestorPitch from './pages/InvestorPitch';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import EnrollPackages from './pages/EnrollPackages';
import EnrollRegister from './pages/EnrollRegister';
import EnrollConsent from './pages/EnrollConsent';
import EnrollChild from './pages/EnrollChild';
import EnrollPayment from './pages/EnrollPayment';
import PaymentSuccess from './pages/PaymentSuccess';
import ObserverChildInteractions from './pages/ObserverChildInteractions';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<UnifiedLogin />} />
          <Route path="/process" element={<Process />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/observer" element={<ObserverLanding />} />
          <Route path="/principal" element={<PrincipalLanding />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/panel" element={<AdminPanel />} />
          <Route path="/admin/communications" element={<AdminCommunications />} />
          <Route path="/operations" element={<OperationsDashboard />} />
          <Route path="/parent/login" element={<ParentLogin />} />
          <Route path="/parent/dashboard" element={<ParentDashboard />} />
          <Route path="/parent/messages" element={<ParentMessages />} />
          <Route path="/parent/support" element={<ParentSupport />} />
          <Route path="/parent/resources" element={<ParentResources />} />
          <Route path="/parent/rewards/:childId" element={<ParentRewards />} />
          <Route path="/parent/mood-journal/:childId" element={<ParentMoodJournal />} />
          <Route path="/parent/goals/:childId" element={<ParentGoals />} />
          <Route path="/parent/community" element={<ParentCommunity />} />
          <Route path="/parent/group-sessions" element={<ParentGroupSessions />} />
          <Route path="/parent/co-guardians/:childId" element={<ParentCoGuardians />} />
          <Route path="/parent/child/:childId/timeline" element={<ChildTimeline />} />
          <Route path="/parent/child/:childId/celebration" element={<ChildCelebration />} />
          <Route path="/parent/weekly-summary" element={<ParentWeeklySummary />} />
          <Route path="/parent/weekly-summary/:childId" element={<ParentWeeklySummary />} />
          <Route path="/parent/daily-insight" element={<ParentDailyInsight />} />
          <Route path="/parent/daily-insight/:childId" element={<ParentDailyInsight />} />
          <Route path="/parent/report/:reportId" element={<ParentReportDetail />} />
          <Route path="/parent/monthly-reports" element={<ParentMonthlyReportsList />} />
          <Route path="/parent/monthly-report/:reportId" element={<ParentMonthlyReport />} />
          <Route path="/parent/subscription" element={<ParentSubscription />} />
          <Route path="/parent/billing" element={<ParentSubscription />} />
          <Route path="/parent/predictive-insights" element={<ParentPredictiveInsights />} />
          <Route path="/parent/predictive-insights/:childId" element={<ParentPredictiveInsights />} />
          
          {/* Observer Routes */}
          <Route path="/observer/login" element={<ObserverLogin />} />
          <Route path="/observer/register" element={<ObserverRegister />} />
          <Route path="/observer/nda" element={<ObserverNDA />} />
          <Route path="/observer/application-status" element={<ObserverApplicationStatus />} />
          <Route path="/observer/dashboard" element={<ObserverDashboard />} />
          <Route path="/observer/today" element={<ObserverToday />} />
          <Route path="/observer/session/:sessionId" element={<ObserverActiveSession />} />
          <Route path="/observer/sessions" element={<ObserverSessionsList />} />
          <Route path="/observer/sessions/:childId" element={<ObserverSessionLogs />} />
          <Route path="/observer/report/:childId" element={<ObserverDailyReport />} />
          <Route path="/observer/reports" element={<ObserverReportsList />} />
          <Route path="/observer/report-detail/:reportId" element={<ObserverReportDetail />} />
          <Route path="/observer/reflections" element={<ObserverSelfReflection />} />
          <Route path="/observer/escalation/:childId" element={<ObserverEscalation />} />
          <Route path="/observer/escalations" element={<ObserverEscalation />} />
          <Route path="/observer/mood-entry/:childId" element={<ObserverMoodEntry />} />
          <Route path="/observer/goal-create/:childId" element={<ObserverGoalCreate />} />
          <Route path="/observer/ai-report/:childId" element={<ObserverAIReport />} />
          <Route path="/observer/events" element={<ObserverEvents />} />
          <Route path="/observer/earnings" element={<ObserverEarnings />} />
          <Route path="/observer/withdrawal" element={<ObserverWithdrawal />} />
          <Route path="/observer/support" element={<ObserverSupport />} />
          <Route path="/observer/add-inquiry" element={<ObserverAddInquiry />} />
          <Route path="/observer/rulebook" element={<ObserverRuleBook />} />
          <Route path="/observer/calls" element={<ObserverCalls />} />
          <Route path="/observer/video-call" element={<ObserverVideoCall />} />
          <Route path="/observer/audits" element={<ObserverAudits />} />
          <Route path="/observer/audit/:auditId" element={<ObserverAuditDetail />} />
          <Route path="/observer/audit/:auditId/view" element={<ObserverAuditDetail />} />
          <Route path="/observer/availability" element={<ObserverAvailability />} />
          <Route path="/observer/handbook" element={<ObserverHandbook />} />
          <Route path="/observer/training" element={<ObserverTraining />} />
          <Route path="/observer/training/:moduleId" element={<ObserverTraining />} />
          <Route path="/observer/assignment" element={<ObserverAssignment />} />
          <Route path="/observer/performance" element={<ObserverPerformance />} />
          <Route path="/observer/quality-metrics" element={<ObserverQualityMetrics />} />
          <Route path="/observer/call-analysis" element={<ObserverCallAnalysis />} />
          <Route path="/observer/prep-notes" element={<ObserverPrepNotes />} />
          <Route path="/observer/prep-notes/:childId" element={<ObserverPrepNotes />} />
          <Route path="/observer/coaching" element={<ObserverCoaching />} />
          <Route path="/observer/career" element={<ObserverCareer />} />
          <Route path="/observer/payslips" element={<ObserverPayslips />} />
          <Route path="/observer/payslip/:year/:month" element={<ObserverPayslips />} />
          
          {/* Parent Insights */}
          <Route path="/parent/insights" element={<ParentInsights />} />
          <Route path="/parent/insights/:childId" element={<ParentInsights />} />
          
          {/* Principal Routes */}
          <Route path="/principal/login" element={<PrincipalLogin />} />
          <Route path="/principal/dashboard" element={<PrincipalDashboard />} />
          <Route path="/principal/students" element={<PrincipalStudents />} />
          <Route path="/principal/analytics" element={<PrincipalAnalytics />} />
          <Route path="/principal/events" element={<PrincipalEvents />} />
          <Route path="/principal/earnings" element={<PrincipalEarnings />} />
          <Route path="/principal/support" element={<PrincipalSupport />} />
          <Route path="/principal/student-assignment" element={<PrincipalStudentAssignment />} />
          <Route path="/principal/observer-performance" element={<PrincipalObserverPerformance />} />
          <Route path="/principal/consultations" element={<PrincipalConsultations />} />
          <Route path="/principal/recordings" element={<PrincipalRecordings />} />
          <Route path="/principal/business" element={<PrincipalBusiness />} />
          <Route path="/principal/payslips" element={<PrincipalPayslips />} />
          <Route path="/principal/payslip/:year/:month" element={<PrincipalPayslips />} />
          <Route path="/principal/red-flags" element={<PrincipalRedFlags />} />
          <Route path="/principal/observers" element={<PrincipalObservers />} />
          <Route path="/principal/child-assignment" element={<PrincipalChildAssignment />} />
          <Route path="/principal/recognition" element={<PrincipalRecognition />} />
          <Route path="/principal/training" element={<PrincipalTrainingHandover />} />
          <Route path="/principal/weekly-questions" element={<PrincipalWeeklyQuestions />} />
          <Route path="/principal/meetings" element={<PrincipalMeetings />} />
          <Route path="/principal/session-history" element={<PrincipalSessionHistory />} />
          <Route path="/principal/monthly-reports" element={<PrincipalMonthlyReports />} />
          <Route path="/principal/review-center" element={<PrincipalReviewCenter />} />
          <Route path="/principal/policy-book" element={<PrincipalPolicyBook />} />
          <Route path="/principal/rule-book" element={<PrincipalRuleBook />} />
          <Route path="/principal/chat" element={<PrincipalChat />} />
          <Route path="/principal/chat/:conversationId" element={<PrincipalChat />} />
          <Route path="/principal/schedule" element={<PrincipalScheduleManagement />} />
          <Route path="/rules" element={<RuleBook />} />
          <Route path="/investor" element={<InvestorPitch />} />
          <Route path="/principal/child/:childId" element={<PrincipalChildDetail />} />
          <Route path="/principal/child/:childId/timeline" element={<ChildTimeline />} />
          <Route path="/principal/child/:childId/celebration" element={<ChildCelebration />} />
          <Route path="/principal/predictive-insights" element={<PrincipalPredictiveInsights />} />
          <Route path="/principal/predictive-insights/:childId" element={<PrincipalPredictiveInsights />} />
          <Route path="/principal/observer/:observerId" element={<PrincipalObserverDetail />} />
          <Route path="/principal/interactions" element={<ObserverChildInteractions />} />
          
          {/* Observer Pre/Post Call */}
          <Route path="/observer/precall/:childId" element={<ObserverPreCall />} />
          <Route path="/observer/precall/:childId/:sessionId" element={<ObserverPreCall />} />
          <Route path="/observer/postcall/:sessionId" element={<ObserverPostCall />} />
          
          {/* Enrollment Flow */}
          <Route path="/enroll" element={<EnrollPackages />} />
          <Route path="/enroll/register" element={<EnrollRegister />} />
          <Route path="/enroll/consent" element={<EnrollConsent />} />
          <Route path="/enroll/child" element={<EnrollChild />} />
          <Route path="/enroll/payment" element={<EnrollPayment />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          
          {/* Demo Audio Analysis Portal */}
          <Route path="/demo/login" element={<DemoLogin />} />
          <Route path="/demo/dashboard" element={<DemoDashboard />} />
          <Route path="/demo/report/:reportId" element={<DemoReportView />} />
          
          {/* Footer Pages */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;